import { Injectable } from "@angular/core";

import { RuntimeConfigService } from "../runtime-config";

import { CrossStorageClient } from "./cross-storage-client";

@Injectable()
export class CrossStorageService {
  constructor(private runtimeConfig: RuntimeConfigService) {}

  get(key: string): Promise<any>;
  get(...keys: string[]): Promise<any[]>;
  async get(...keys: string[]): Promise<any[]> {
    const client = await this.getClient();
    // veracode 💩💩💩
    return client.get.call(client, ...keys);
  }

  async getKeys(): Promise<string[]> {
    const client = await this.getClient();
    return client.getKeys();
  }

  async set(key: string, value: any, ttl?: number): Promise<void> {
    const client = await this.getClient();
    return client.set(key, value, ttl);
  }

  async del(...keys: string[]): Promise<void> {
    const client = await this.getClient();
    return client.del(...keys);
  }

  async clear(): Promise<void> {
    const client = await this.getClient();
    return client.clear();
  }

  private client: Promise<CrossStorageClient>;
  private getClient(): Promise<CrossStorageClient> {
    if (this.client == null) {
      this.client = new Promise(async (resolve, reject) => {
        const { globalAuthUrl } = await this.runtimeConfig.value,
          client = new CrossStorageClient(
            `${globalAuthUrl}/local/assets/cross-storage/hub.html`,
            {}
          );
        await client.onConnect();
        resolve(client);
      });
    }
    return this.client;
  }
}
